<template>
  <div class="w-full">
    <div class="hidden md:block">
      <PlotTooltip v-for="plot of plots" :key="plot.ID" :item="plot" />
      <div class="hidden" id="sold-popup">
        <div class="">
          <div
            class="
              bg-gray-600
              text-white text-lg text-center
              font-bold
              py-3
              px-8
              rounded-t-3xl
            "
          >
            Solgt
          </div>
          <div class="py-2 px-5 text-center text-black">
            <div class="capitalize">{{ ' ' }}</div>
          </div>
        </div>
      </div>
    </div>
    <svg
      fill="none"
      height="828"
      viewBox="0 0 1514 828"
      width="1514"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      class="w-full h-auto"
    >
      <pattern
        id="a"
        height="1"
        patternContentUnits="objectBoundingBox"
        width="1"
      >
        <image
          height="1374"
          transform="matrix(.0004985 0 0 .00091152 0 -.126212)"
          width="2006"
          :xlink:href="map"
        />
      </pattern>
      <path d="m0 0h1514v828h-1514z" fill="url(#a)" />
      <!-- sold items -->
      <g fill="#797d86">
        <path
          v-for="(item, i) in sold"
          :key="i"
          :d="item"
          v-tippy="{
            html: `#sold-popup`,
            interactive: false,
            delay: [0, 0],
            animateFill: false,
            interactiveBorder: 0,
            theme: 'aksdal',
            followCursor: false,
            arrow: true,
            arrowType: 'sharp',
            placement: 'top',
          }"
        />
      </g>
      <path
        v-for="element in elements"
        :class="
          !disabled.includes(+element.id) ? 'selector-item' : 'disabled-item'
        "
        :data-cos="element.id"
        :key="element.id || 123123"
        :d="element.position"
        @click="handleClick(element.id)"
        v-tippy="{
          html: `#tomt-${element.id}`,
          interactive: false,
          delay: [0, 0],
          animateFill: false,
          interactiveBorder: 0,
          theme: 'aksdal',
          followCursor: false,
          arrow: true,
          arrowType: 'sharp',
          placement: 'top',
        }"
      />
    </svg>
  </div>
</template>

<script>
import PlotTooltip from '../partials/PlotTooltip.vue';
export default {
  name: 'InteractiveMap',
  components: {
    PlotTooltip,
  },
  props: {
    map: {
      type: String,
      required: true,
    },
    plots: {
      type: Array,
      required: true,
      default: [],
    },
    disabled: {
      type: Array,
      required: true,
      default: [],
    },
  },
  data() {
    return {
      sold: [
        'm537.814 285.255-2.824 45.977 64.648 4.591 2.975-46.4z',
        'm606.518 289.671-3.29 46.854 62.321 4.007 3.289-46.854z',
        'm669.98 340.708 62.951 4.679 6.985-93.225-64.213-4.358z',
        'm669.079 289.876 2.598-42.072-62.305-2.545-2.614 40.61z',
        'm602.853 285.621 2.283-40.888-64.528-2.866-2.359 39.586z',
        'm729.717 366.679-6.324 94.937s.256 16.378-6.414 21.935c-2.778 2.296-7.675 5.645-19.617 4.723-11.941-.921-35.223-3.144-35.223-3.144l10.334-122.531z',
        'm657.318 483.975-68.449-5.762 9.838-121.098 69.41 4.841z',
        'm960.688 385.119s-1.652 38.724-3.424 46.986l-48.427-1.711 3.921-49.72z',
        'm956.933 436.024s-4.791 31.119-12.827 57.383l-43.019-5.103 7.255-54.108z',
        'm943.79 496.902s-12.377 45.758-21.975 67.342l-33.886-16.086 12.677-56.155z',
        'm896.505 491.696-12.271 55.102-38.017-15.296 3.409-43.564z',
        'm897.196 487.938-47.239-3.071 3.004-53.596 51.1 2.589z',
        'm904.842 430.131-51.551-2.676 3.861-50.423 51.7 3.671z',
        'm836.063 375.073-3.245 59.416-39.774-3.334 4.251-59.314z',
        'm792.593 371.432-3.83 59.342-39.264-3.524 3.35-59.152z',
        'm792.758 435.118 39.835 3.568-6.203 78.938-39.369-2.486z',
        'm788.462 434.854-5.722 79.977-39.279-2.793 5.677-80.591z',
        'm826.389 522.611-3.169 50.934-88.742-6.201-16.793-43.666 28.705 4.855.781-10.909z',
        'm912.187 600.744-11.386 23.588-63.987-4.021 1.712-19.084 2.734.044 4.912-43.505 62.335 23.47-4.671 16.203z',
        'm834.395 600.964-7.81 89.54-52.557-42.379-27.443-46.869-10.815-29.379 86.834 5.601-1.397 22.477z',
        'm986.569 121.69s12.873 40.683 7.51 73.454l88.381 9.067s-10.63-39.791-4.16-70.34c-.02 0-52.56-12.649-91.731-12.181z',
        'm993.553 198.903s-9.823 33.634-12.482 48.916l109.889 8.013 13.04-21.306s-17.45-14.258-20.74-26.016z',
        'm980.756 251.401s-6.414 31.119-6.489 51.855l95.923 5.294 19.33-49.471z',
        'm974.267 307.644 8.081 63.013 71.352 5.103 15.2-62.033z',
        'm982.348 374.459-1.772 51.68 64.734 5.966 8.04-51.826z',
        'm980.576 430.131-8.156 44.149 61.48 13.395 10.3-50.803z',
        'm970.978 478.301-10.29 40.405 60.042 18.85 11.94-44.573z',
        'm959.772 523.21-23.958 62.926 59.197 21.804 24.019-63.847z',
        'm993.689 611.975-17.394 43.608-61.269-27.77 8.922-23.12 4.867 1.477 6.098-17.227z',
        'm974.267 659.751-20.773 60.249-106.121-12.547-17.033-13.161 6.444-70.164 66.421 4.167 12.707-26.293 4.341 1.448-10.154 26.293z',
        'm700.096 181.076-3.154 46.869 45.963 1.74-1.487-54.546z',
      ],
      elements: [
        {
          id: 52,
          position:
            'm965.375 123.255c3.841 15.898 6.656 32.016 8.426 48.258l-65.354 16.758-1.037-51.957z',
        },
        {
          id: 46,
          position: 'm903.355 137.352.856 52.937-81.562 20.269-.766-53.523z',
        },
        {
          id: 45,
          position: 'm818.083 157.371 1.006 55.117-57.078 14.258-3.169-54.444z',
        },
        {
          id: 51,
          position:
            'm967.733 196.007s-6.819 36.837-12.482 50.13l-52.091-3.89 1.412-30.095z',
        },
        {
          id: 50,
          position:
            'm953.779 249.983c-2.564 16.361-3.939 32.878-4.116 49.428l-49.868-3.115 3.109-49.867z',
        },
        {
          id: 47,
          position: 'm900.756 213.043-4.055 69.945-81.502-6.8 1.998-42.16z',
        },
        {
          id: 44,
          position: 'm813.126 236.544-2.809 53.8-49.898-3.32 2.268-38.898z',
        },
        {
          id: 43,
          position: 'm759.878 291.177-4.146 56.184 51.116 3.335 3.469-56.535z',
        },
        {
          id: 48,
          position: 'm814.989 280.224-3.921 70.398 80.676 5.645 4.701-69.257z',
        },
        {
          id: 49,
          position: 'm899.525 300.434-3.59 56.418 57.859 2.822-4.206-56.169z',
        },
        {
          id: 23,
          position:
            'm585.129 476.707 9.808-119.592-64.573-4.416-9.689 128.468 36.56-6.887z',
        },
        {
          id: 24,
          position:
            'm516.56 482.966-16.253 4.27-51.535-1.477 5.888-60.352 3.259-.263 5.813-76.686 62.456 3.846z',
        },
        {
          id: 42,
          position: 'm427.262 485.072-67.262-4.051 7.15-85.563 66.466 3.92z',
        },
        {
          id: 41,
          position: 'm433.871 395.575-66.571-4.592 4.176-54.004 66.015 4.518z',
        },
        {
          id: 40,
          position: 'm437.747 337.695 3.77-56.125-65.505-3.115-4.221 54.634z',
        },
        {
          id: 39,
          position: 'm441.652 277.753 3.545-51.153-65.46-.98-3.71 49.018z',
        },
        {
          id: 35,
          position: 'm468.749 281.643-3.68 45.172 65.715 3.627 3.124-45.45z',
        },
        {
          id: 36,
          position: 'm536.417 241.867-2.268 39.322-65.61-2.91 3.049-39.366z',
        },
        {
          id: 38,
          position:
            'm460.142 214.798-28.163-.585-.932 5.192-50.379-1.901 1.758-40.361 37.671-66.143 47.435 22.067z',
        },
        {
          id: 37,
          position:
            'm472.159 134.836-7.375 80.65 66.436 2.646 5.197-56.549-30.116-13.059z',
        },
        {
          id: 28,
          position: 'm540.292 161.978-4.431 56.637 66.541 4.285 3.26-48.668z',
        },
        {
          id: 27,
          position: 'm608.966 175.139-3.169 47.966 87.105 4.255 4.04-46.883z',
        },
      ],
    };
  },

  methods: {
    handleClick(id) {
      window.location.href = `${window.location.origin}/plot/tomt-${id}/`;
    },
  },
};
</script>
